import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    slider: {
      height: '100%',
      [theme.fn.largerThan('sm')]: {
        padding: '10px 5px',
      },
    },
  }
})
